import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '../../../../../../../JustificationContainer';
import ProgressiveImgIx from '../../../../../../../ProgressiveImgIx';
import { Heading4 } from '../../../../../../../Typography';

export type Props = {
  dataTestId?: string;
  title: React.ReactNode;
  icon: { src: string };

  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const ListItem: React.FC<Props> = ({
  dataTestId,
  title,
  icon,
  onClick,
  ...rest
}) => (
  <Container
    data-testid={dataTestId}
    {...rest}
    padding={['s']}
    align="center"
    onClick={onClick}
  >
    <IconWrapper align="center" justification="center">
      <ProgressiveImgIx width={ICON_SIZE} src={icon.src} />
    </IconWrapper>
    <JustificationContainer direction="column">
      <Title withoutMargin>{title}</Title>
    </JustificationContainer>
  </Container>
);

const IconWrapper = styled(JustificationContainer)<{}>(
  ({ theme }) => css`
    width: 100%;
    height: ${ICON_SIZE}px;
    max-width: ${ICON_SIZE}px;
    flex-shrink: 0;
    padding: ${theme.space('xxxs')};
    margin-right: ${theme.space('base')};

    img {
      transform: scale(1);
      transition: all 0.2s ease-out;
    }
  `,
);

const Container = styled(JustificationContainer)<{}>(
  ({ theme }) => css`
    border-radius: ${theme.getSystem().border.radius.base};
    border: 1px solid transparent;
    transition: all 0.2s ease-out;
    cursor: pointer;
    background-color: #fff;
    margin: 0;
    box-shadow: ${theme.boxShadow('s')};

    &:hover {
      ${IconWrapper} img {
        transform: scale(1.2);
      }
    }
  `,
);

const Title = styled(Heading4)<{}>(
  ({ theme }) => css`
    font-weight: ${theme.fw('regular')};
    color: #000;
    user-select: none;
  `,
);

const ICON_SIZE = 60;

export default ListItem;
